import { Suspense, useEffect, useMemo, useState } from 'react'
import { Route, Routes } from 'react-router-dom'

import { Helmet, ScrollToTop, CookieModal } from 'components'

import routesList from './routes'

// const ScrollToTop = () => {
//   const location = useLocation()

//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       left: 0,
//       behavior: 'smooth',
//     })
//   }, [location])

//   return null
// }

export const RoutesWrapper = () => {
  const [showCookieModal, setShowCookieModal] = useState(false)

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent')
    if (!cookieConsent) {
      setShowCookieModal(true)
    }
  }, [])

  const renderRoutes = useMemo(
    () =>
      routesList.map(({ element: Element, path, title }) => (
        <Route
          key={path}
          path={path}
          element={
            <Suspense>
              <Helmet key={title} title={title}>
                <Element />
              </Helmet>
            </Suspense>
          }
        />
      )),

    []
  )

  return (
    <>
      <Routes>{renderRoutes}</Routes>
      <ScrollToTop />
      <CookieModal show={showCookieModal} setShow={setShowCookieModal} />
    </>
  )
}
